var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-md mx-auto h-auto px-4 py-6 mt-10 mb-10 border border-gray-200 bg-gray-50"},[_c('router-view',{attrs:{"name":"main"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }